<template>
  <div class="aboutUs" id="aboutUs">
    <my-header />

    <!-- 标题关于我们 -->
    <div class="pre">
      <div class="allTitle">
        <span>关于我们</span>
      </div>
      <div class="allWord">
        <p class="p1">中国纯铜智能门锁制造先驱</p>
        <p class="p2">纯铜五金制造专家</p>
      </div>
    </div>

    <!-- 图片1 -->
    <div class="img1">
      <img src="../assets/20.jpg" />
    </div>

    <div class="pre">
      <div class="start">
        <b-container>
          <b-row>
            <b-col class="text-center" xs="12" sm="12" md="6" lg="6" xl="6">
              <img src="../assets/21.jpg" />
            </b-col>
            <b-col xs="12" sm="12" md="6" lg="6" xl="6">
              <p class="p1">
                在<br />
                一开始<br />
                的时候<br />
              </p>
              <p class="p2">瀚佰锐</p>
              <p class="p3">
                这个寓意“采集众人之长”的名字，<br />
                是金发五金制品有限公司<br />
                在2011年倾力打造的一个高档铜质门用装饰五金品牌。<br />
                它是金发人经深思熟虑而推出的一个品牌，<br />
                可以说，它的确聚焦了金发众人甚至整个装饰五金市场的经验和智慧。
              </p>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>

    <div class="pre">
      <div class="carouselBorder">
        <div class="carousel">
          <b-carousel
            id="carousel-1"
            :interval="4000"
            controls
            indicators
            background="#ababab"
            style="text-shadow: 1px 1px 2px #333;"
          >
            <div v-for="(current, i) in dataList">
              <b-carousel-slide :img-src="current.imgPath"></b-carousel-slide>
            </div>
          </b-carousel>
        </div>
      </div>
    </div>

    <!-- <div class="pre">
			<div class="carouselBorder">
				<div class="carousel">
					<b-carousel id="carousel-1" v-model="slide" :interval="4000" controls indicators background="#ababab" style="text-shadow: 1px 1px 2px #333;">
						<b-carousel-slide>
							<template v-slot:img>
								<img class="d-block img-fluid w-100" width="1024" height="480" src="../assets/22.jpg" alt="image slot">
							</template>
						</b-carousel-slide>
					</b-carousel>
				</div>
			</div>
		</div>
		 -->

    <div class="pre">
      <div class="qualityBorder">
        <div class="quality">
          <b-container>
            <b-row>
              <b-col class="text-center" xs="12" sm="12" md="6" lg="6" xl="6">
                <img src="../assets/23.jpg" />
              </b-col>
              <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                <p class="p1">以质量取胜</p>
                <p class="p2">
                  在金发公司创业到今的30多年中，金发人本着<br />
                  "以质量赢取市场、回馈广大消费者的原则"，<br />
                  一直不断地努力学习钻研现代铜加工工艺，<br />
                  最终建立起了一条由<br />
                  材料到成品的一体化生产线。<br />
                  这生产不但保证生产流程的顺畅和对产品品质的全面监控，<br />
                  更有效地控制了产品的成本。
                </p>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
    </div>

    <div class="pre">
      <div class="innovate">
        <b-container>
          <b-row>
            <b-col xs="12" sm="12" md="6" lg="6" xl="6">
              <p class="p1">
                创新<br />
                研发<br />
              </p>
              <p class="p2">
                一直追求对装饰五金款式的自我创新，<br />
                大力开展产品开发，<br />
                其设计研发部更通过将<br />
                欧式、中式经典元素融入现代简约时尚的风格，<br />
                创造出<br />
                瀚佰锐式的“古典与时尚结合”的独特品味。<br />
                这样，<br />
                瀚佰锐被定位为高性价比，高品质的时尚装饰五金，<br />
                同时<br />
                也造就出瀚佰锐人即务实稳重，又不失年轻活力；<br />
                既尊崇古典传统，又追求时尚的“瀚佰锐文化”。
              </p>
            </b-col>
            <b-col class="text-center" xs="12" sm="12" md="6" lg="6" xl="6">
              <img src="../assets/24.jpg" />
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>

    <div class="pre">
      <div class="makeBorder">
        <div class="make">
          <b-container>
            <b-row>
              <b-col class="text-center" xs="12" sm="12" md="6" lg="6" xl="6">
                <img src="../assets/25.jpg" />
              </b-col>
              <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                <p class="p1">
                  制造<br />
                  大众买得起的<br />
                  豪华铜质装饰五金<br />
                </p>
                <p class="p2">
                  金发董事长为瀚佰锐定下了这样一个长期发展目标：<br />
                  “制造大众买得起的豪华铜质装饰五金”。<br />
                  展望未来，品牌“瀚佰锐”将大力打进市场，<br />
                  让广大消费者和商家在选购装饰五金的时候，<br />
                  有一个更放心，更实惠，更高品质的选择！
                </p>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
    </div>

    <!--这个怎么做 -->
    <div class="pre" id="doIt">
      <div class="doit">
        <div class="doTitle">这个是怎么做的</div>
        <div class="doWord">
          耗时的制造过程可实现完全定制，从开始到结束，每件作品均需触摸不少于30只手。
        </div>
      </div>
    </div>

    <div class="pre">
      <div class="footimg clear">
        <div class="itemImg left">
          <img src="../assets/11.jpg" />
          <span>模具</span>
          <p style="width: 70%;">全面卓越的模具开发与生产能力</p>
        </div>
        <div class="itemImg left">
          <img src="../assets/12.jpg" />
          <span>锻压</span>
          <p>久经钻研的锻压红冲工艺</p>
        </div>
        <div class="itemImg left">
          <img src="../assets/13.jpg" />
          <span>精加工</span>
          <p>精密且配合到位的CNC精加工</p>
        </div>
        <div class="itemImg left">
          <img src="../assets/14.jpg" />
          <span>表面处理</span>
          <p>完美无瑕的抛光和表面处理</p>
        </div>
        <div class="itemImg left">
          <img src="../assets/15.jpg" />
          <span>成品</span>
          <p>艺术品般的高品质成品</p>
        </div>
      </div>
    </div>

    <myFooter />
  </div>
</template>

<script>
import myHeader from "@/views/myHeader.vue";
import myFooter from "@/views/myFooter.vue";

export default {
  components: {
    myHeader,
    myFooter
  },
  data() {
    return {
      dataList: []
    };
  },
  mounted() {
    if (this.$route.query.go) {
      document.querySelector("#" + this.$route.query.go).scrollIntoView(true);
    }
    let that = this;
    that.$axios
      .get(that.$global.baseURL + "/web/modules/getModulesByCatalogId.form", {
        params: {
          catalogId: "6"
        }
      })
      .then(res => {
        if (res.data.jsonArray == "error") {
          uni.showModal({
            title: res.data.errorInfo,
            showCancel: false
          });
        } else {
          that.dataList = res.data.dataList;
        }
      });
  }
};
</script>

<style>
/*最外层 */
.aboutUs .pre {
  width: 100%;
}

.aboutUs .pre .allTitle {
  width: 90%;
  text-align: center;
  margin: 0 auto;
  color: #8d8c8c;
  font-size: 53px;
  padding-top: 40px;
  letter-spacing: 10px;
  font-weight: lighter;
}

.aboutUs .allWord p {
  text-align: center;
  font-size: 16px;
  margin-bottom: 0;
  padding: 3px 0;
  color: #595757;
  line-height: 30px;
  letter-spacing: 5px;
}

.aboutUs .allWord .p1 {
  letter-spacing: 25px;
  margin: 10px 0 5px;
  margin-left: 20px;
}

.aboutUs .img1 img {
  width: 100%;
  padding-top: 45px;
}

/* “从一开始的时候”的样式 */
.aboutUs .start {
  width: 86%;
  margin: 0 auto;
  margin-top: 80px;
}

.aboutUs .start img {
  width: 90%;
  margin: 0 auto;
}

.aboutUs .start p {
  margin-left: 17px;
  color: #595757;
  letter-spacing: 2px;
}

.aboutUs .start .p1 {
  font-size: 35px;
  font-weight: lighter;
}

.aboutUs .start .p2 {
  font-size: 20px;
  margin-top: 50px;
}

.aboutUs .start .p3 {
  font-size: 14px;
  line-height: 30px;
  margin-top: 20px;
}

/* 轮播图 */
.aboutUs .carouselBorder {
  width: 80%;
  margin: 0 auto;
}

.aboutUs .carousel {
  width: 100%;
  margin-top: 80px;
  margin-bottom: 80px;
  border-bottom: 1px solid #c4c4c4;
}

.carousel .carousel-indicators {
  display: none;
}

/* 以质量取胜的样式 */
.qualityBorder {
  width: 80%;
  margin: 0 auto;
  border-bottom: 1px solid #c4c4c4;
}

.quality {
  width: 100%;
  margin: 0 auto;
  margin-top: 80px;
  margin-bottom: 80px;
}

.quality img {
  width: 100%;
  margin: 0 auto;
  margin-left: -30px;
}

.quality p {
  margin-left: 50px;
  padding-top: 30px;
  color: #595757;
  letter-spacing: 2px;
}

.quality .p1 {
  font-size: 40px;
  font-weight: lighter;
}

.quality .p2 {
  font-size: 14px;
  line-height: 30px;
}

/* 创新研发的样式 */
.innovate {
  width: 80%;
  margin: 0 auto;
  margin-top: 80px;
  margin-bottom: 80px;
}

.innovate img {
  width: 100%;
  margin: 0 auto;
  margin-right: -13px;
}

.innovate p {
  margin-left: -15px;
  padding-top: 30px;
  color: #595757;
  letter-spacing: 2px;
}

.innovate .p1 {
  font-size: 40px;
  font-weight: lighter;
}

.innovate .p2 {
  font-size: 14px;
  line-height: 30px;
}

/* “制造那段文字”的样式 */

.makeBorder {
  width: 80%;
  margin: 0 auto;
  border-top: 1px solid #c4c4c4;
  border-bottom: 1px solid #c4c4c4;
}

.make {
  width: 100%;
  margin: 0 auto;
  margin-top: 80px;
  margin-bottom: 80px;
}

.make img {
  width: 100%;
  margin: 0 auto;
  margin-left: -30px;
}

.make p {
  margin-left: 50px;
  padding-top: 30px;
  color: #595757;
  letter-spacing: 2px;
}

.make .p1 {
  font-size: 40px;
  font-weight: lighter;
}

.make .p2 {
  font-size: 14px;
  line-height: 30px;
  padding-top: 60px;
}

/* 这个怎么做的样式 */
.doit {
  max-width: 1030px;
  margin: 0 auto;
  margin-top: 80px;
  padding-left: 10px;
  color: #595757;
  letter-spacing: 2px;
}

.doit .doTitle {
  font-size: 36px;
  padding-bottom: 15px;
  font-weight: lighter;
}

.footimg {
  /* width: 80%; */
  max-width: 1030px;
  margin: 0 auto;
  margin-top: 30px;
  padding-bottom: 30px;
  padding-left: 1%;
}

.footimg .itemImg {
  width: 20%;
}

.footimg .itemImg img {
  width: 95%;
  padding-bottom: 10px;
}

.footimg .itemImg .longWord {
  width: 85%;
  margin-top: 5px;
}

.footimg .itemImg div {
  margin-top: 5px;
}

.footimg .itemImg span {
  font-size: 18px;
  font-weight: bold;
  margin-top: 12px;
}

.footimg .itemImg p {
  font-size: 12px;
  letter-spacing: 2px;
  margin-top: 10px;
}

/* 媒体查询 */
@media screen and (max-width: 850px) {
  .aboutUs .start .p1 {
    margin-top: 15px;
    margin-top: 15px;
  }

  .aboutUs .start .p2 {
    margin-top: 30px;
  }

  .quality {
    margin-top: 30px;
    margin-bottom: 40px;
  }

  .quality img {
    margin-left: 0;
    margin: 0 auto;
  }

  .quality p {
    margin-left: 0;
  }

  .quality .p2 {
    padding-top: 0px;
  }

  .innovate {
    width: 80%;
    margin-top: 15px;
    margin-bottom: 40px;
  }

  .innovate img {
    margin-right: 0;
  }

  .innovate p {
    margin-left: 0;
  }

  .innovate .p1 {
    margin-bottom: 15px;
  }

  .innovate .p2 {
    padding-top: 0px;
    margin-bottom: 15px;
  }

  .make {
    margin-top: 40px;
    margin-bottom: 40px;
  }

  .make img {
    margin-left: 0;
  }

  .make p {
    margin-left: 0;
  }

  .make .p2 {
    padding-top: 20px;
  }

  .doit {
    width: 85%;
    margin-top: 40px;
  }

  .footimg {
    padding-bottom: 50px;
  }

  .aboutUs .carousel {
    margin-top: 40px;
    margin-bottom: 60px;
  }
}
</style>
